module.exports = __webpack_public_path__ + "static/media/campana_entrada_blanco.b09b95c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/campana_entrada_blanco.svg
// module id = 1735
// module chunks = 0